import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const InvoiceStatementService = {};

// Tìm hóa đơn đủ điều kiện để lập bảng kê thay thế / điều chỉnh
// axios tự serialize mảng thành invoice_numbers[]=97&invoice_numbers[]=145
InvoiceStatementService.prepareStatement = params =>
  fetch({
    url: `${env.API_MSP}/statements/prepare`,
    method: "get",
    params,
  });

// Tạo bảng kê từ các hóa đơn đã chọn
InvoiceStatementService.initStatement = data =>
  fetch({
    url: `${env.API_MSP}/statements/init`,
    method: "post",
    data,
  });

// Lấy chi tiết bảng kê để hiển thị / chỉnh sửa
InvoiceStatementService.getStatementDetail = statementId =>
  fetch({
    url: `${env.API_MSP}/statements/${statementId}`,
    method: "get",
  });

// Trạng thái file PDF của bảng kê (backend tạo bất đồng bộ)
InvoiceStatementService.getStatementPdfStatus = statementId =>
  fetch({
    url: `${env.API_MSP}/statements/pdf/${statementId}`,
    method: "get",
  });

// Tải file PDF bảng kê về dạng blob để xem trên modal
InvoiceStatementService.downloadStatementPdf = statementId =>
  fetch({
    url: `${env.API_MSP}/statements/download/${statementId}`,
    method: "get",
    responseType: "blob",
  });

// Lưu nội dung bảng kê sau khi điều chỉnh
InvoiceStatementService.saveStatement = data =>
  fetch({
    url: `${env.API_MSP}/statements/save`,
    method: "post",
    data,
  });

// Bản hiển thị PDF của một hóa đơn trong danh sách hợp lệ
InvoiceStatementService.reviewInvoicePdf = invoiceId =>
  fetch({
    url: `${env.API_MSP}/invoices/review-pdf/${invoiceId}`,
    method: "get",
  });

// Gợi ý người mua cho ô tìm kiếm, giới hạn trong chi nhánh đang chọn ở header
InvoiceStatementService.searchBuyers = ({ bucode, keyword }) =>
  fetch({
    url: `${env.API_MSP}/statements/buyers`,
    method: "get",
    params: { bucode, keyword },
  });

// Danh sách bảng kê đã lập
InvoiceStatementService.listStatements = params =>
  fetch({
    url: `${env.API_MSP}/statements`,
    method: "get",
    params,
  });

// Gửi yêu cầu ký số bảng kê. Việc ký chạy bất đồng bộ phía mssigning,
// response chỉ báo đã nhận yêu cầu (status = submitting) kèm poll_url.
InvoiceStatementService.signStatement = statementId =>
  fetch({
    url: `${env.API_MSP}/statements/sign/${statementId}`,
    method: "post",
  });

// ===== Luồng duyệt bảng kê =====

// Cửa hàng gửi bảng kê cho kế toán duyệt, kèm email người mua nhận link ký
InvoiceStatementService.submitStatement = ({ statementId }) =>
  fetch({
    url: `${env.API_MSP}/statements/workflow/${statementId}/submit`,
    method: "post",
  });

// Kế toán duyệt bảng kê; duyệt xong phía gọi mới gửi yêu cầu ký
InvoiceStatementService.approveStatement = statementId =>
  fetch({
    url: `${env.API_MSP}/statements/workflow/${statementId}/approve`,
    method: "post",
  });

// Kế toán từ chối duyệt bảng kê, kèm lý do từ chối
InvoiceStatementService.rejectStatement = ({ statementId, note }) =>
  fetch({
    url: `${env.API_MSP}/statements/workflow/${statementId}/reject`,
    method: "post",
    data: { note },
  });

// Hủy bảng kê còn lưu tạm (approve_status = M)
InvoiceStatementService.cancelStatement = statementId =>
  fetch({
    url: `${env.API_MSP}/statements/cancel/${statementId}`,
    method: "post",
  });

export default InvoiceStatementService;
